"use strict";

angular.module("core")
.controller("PartnershipsFinancialOverdueConfirmationController", function(
    $rootScope, $scope, $attrs, close, FormError
) {
    var _this = this;
    var INPUT_NAME_PREFIX = "net_payment_days_";

    $scope.message = $attrs.message;
    $scope.selectedInstances = $attrs.selectedInstances;
    $scope.text = $attrs.text;
    $scope.netPaymentDaysValueRequired = $attrs.params.netPaymentDaysValueRequired;

    this.close = function(confirm) {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if (confirm) {
            close.apply(this, arguments);
        }
    };

    this.confirm = function() {
        _this.close(true);
    };

    this.submit = function() {
        $scope.partnershipsForm.$setSubmitted();
        if ($scope.partnershipsForm.$valid) {
            var net_payment_days_values = [];
            angular.forEach($scope.partnershipsForm, function(value, key) {
                if (key[0] !== "$" && value.hasOwnProperty("$modelValue")) {
                    net_payment_days_values.push({"id": key.replace(INPUT_NAME_PREFIX, ""), "net_payment_days": value.$modelValue});
                }
            });

            $scope.$element.modal("hide");
            $scope.$element.remove();
            var modalFormData = {
                selectedInstances: $scope.selectedInstances,
                net_payment_days: net_payment_days_values
            };
            close.apply(this, [modalFormData]);
        }
        else {
            FormError.focus("partnershipsForm");
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/action-modal/partnership-financial-overdue-confirmation.modal.js
// module id = 906
// module chunks = 0